// This alphabet uses `A-Za-z0-9_-` symbols.
// The order of characters is optimized for better gzip and brotli compression.
// Same as in non-secure/index.js
let urlAlphabet =
  'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict'

module.exports = { urlAlphabet }



/*****************
 ** WEBPACK FOOTER
 ** ./~/nanoid/url-alphabet/index.cjs
 ** module id = 1031
 ** module chunks = 0
 **/